// extracted by css-extract-rspack-plugin
export default {"tab":"C0Uvn","selected":"u5l2w","label":"HEGc7"};